var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeemee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 22C18.0595 22 22.9844 17.0751 22.9844 11C22.9844 4.92487 18.0595 0 11.9844 0C5.90924 0 0.984375 4.92487 0.984375 11C0.984375 17.0751 5.90924 22 11.9844 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55504 16.6965C6.36919 16.6099 7.54059 15.6879 8.13654 15.1407C9.29804 14.0743 10.379 12.6898 11.2307 11.3633C11.8684 10.37 13.0367 8.34542 12.9941 7.17078C12.9549 6.09419 11.4489 5.69881 10.5892 5.58224C8.8174 5.34192 6.99249 5.69089 5.25842 6.02925C5.48471 5.21025 6.12221 4.53569 6.79965 4.05396C9.34949 2.24074 14.1419 1.78222 17.0274 2.9216C18.1655 3.37095 19.2653 4.19841 19.4641 5.48565C19.4787 5.58008 19.5343 6.11236 19.4844 6.15265C18.9072 6.18953 18.3771 6.40772 17.8946 6.71244C15.6963 8.10132 13.6686 12.0674 13.8019 14.6553C13.8298 15.1961 13.9525 15.6636 14.3601 16.0399C15.0958 16.7193 16.1455 16.5283 17.0467 16.3874C17.9653 16.2439 18.8719 16.0286 19.7838 15.8507C19.7359 16.2408 19.5364 16.6389 19.3112 16.9611C18.2557 18.4714 15.8488 19.2611 14.109 19.5838C12.4577 19.8901 10.6565 19.9651 8.99386 19.7153C7.53933 19.4967 5.16362 18.8162 5.04256 17.0289C5.0395 16.9828 5.02907 16.6963 5.06936 16.6963C5.22514 16.6844 5.40232 16.7125 5.55504 16.6963V16.6965Z",
    fill: "#F16822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeemee);
export default __webpack_public_path__ + "static/media/zeemee.90976c3723c79aeff212b8cc4eae858e.svg";
export { ForwardRef as ReactComponent };